import * as React from "react"

const NavigationIcon = () => (
  <svg
    width={34}
    height={34}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="m28.475 13.53 3.885 3.704-3.885 3.703M13.935 6.236l3.69-3.898 3.69 3.898M6.245 20.934 2.36 17.23l3.885-3.703M21.31 28.439l-3.69 3.898-3.69-3.898"
      stroke="#565656"
      strokeWidth={2}
      strokeLinecap="square"
    />
  </svg>
)

export default NavigationIcon